module.exports = {
  CREDIT_CARD: 1,
  BILLET: 2,
  RECURRENT: 3,
  RECURRENT_PAID: 4
};